import axios from 'axios';

export const httpClient = axios.create({
  // baseURL: 'http://68.178.174.119:5000',
  baseURL: "https://membershipgalaxy.com"
  // baseURL: 'http://localhost:8881',

});